function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { VT_FORM_DATA_UPDATE, VT_FORM_STATE_RECEIVED, VT_FORM_STATE_REQUEST, VT_FORM_STATE_REQUEST_FAILED } from '@engine/actions/action-types';
import financialServicesBins from '@engine/features/financial_services_bins';
import vtOnTerminalChange from '@engine/features/virtual_terminal/vt_terminal_change';
/* Trigger update for the VT State reducer */

export var requestVtFormState = function requestVtFormState() {
  return {
    type: VT_FORM_STATE_REQUEST
  };
};
export var failedVtFormStateRequest = function failedVtFormStateRequest() {
  return {
    type: VT_FORM_STATE_REQUEST_FAILED
  };
};
export var receivedVtFormState = function receivedVtFormState() {
  return {
    type: VT_FORM_STATE_RECEIVED
  };
};
/* Trigger update for the VT Form data reducer */

export var updateVtFormData = function updateVtFormData(data) {
  return {
    type: VT_FORM_DATA_UPDATE,
    data: data
  };
};
export function onTerminalChange(url, terminalId) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
  return function (dispatch, getState) {
    var data = {
      terminal_id: terminalId,
      transaction_type: getState().virtualTerminalFormData.transactionType,
      request_bins: financialServicesBins.isIncomplete(),
      vt_features_requested: true
    };
    return fetch("".concat(url, "?").concat(new URLSearchParams(data).toString()), _objectSpread(_objectSpread({}, data), {}, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      }
    })).then(function (response) {
      return response.json();
    }).then(function (json) {
      dispatch(receivedVtFormState());
      dispatch(updateVtFormData(_objectSpread({
        terminalId: terminalId
      }, json.features)));
      /*
       * Legacy code dependent on terminal-change request
       */

      vtOnTerminalChange.virtualTerminalStateDataReceived(json);
    })["catch"](function () {
      return dispatch(failedVtFormStateRequest());
    });
  };
}